<template>
  <div class="mt-3">
    <v-toolbar flat color="white" >
      <v-flex xs4 mx-1:key="key">
              <v-menu :close-on-content-click="false">
                <v-text-field
                  id="addDateId"
                  :value="this.billingStart"
                  slot="activator"
                  required
                  label="Bill From"
                  prepend-icon="date_range"
                ></v-text-field>
                <v-date-picker v-model="billingStart"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs4 mx-1 :key="key">
              <v-menu :close-on-content-click="false">
                <v-text-field
                  id="addDateId"
                  :value="this.billingEnd"
                  slot="activator"
                  required
                  label="Bill To"
                  prepend-icon="date_range"
                ></v-text-field>
                <v-date-picker v-model="billingEnd"></v-date-picker>
              </v-menu>
            </v-flex>
      <v-spacer></v-spacer>
      <v-btn  round color="primary" class="white--text" v-if="authAdmin($store.state.currentRoute)&&billingStart&&billingEnd" @click="getbillingData()">Get Billing Data</v-btn>
      <v-btn v-show="allBilling.length>0" round color="primary">
          <v-icon>get_app</v-icon>
          <download-excel
            :data="allBilling"
            :fields="exportFields"
            worksheet="export"
            :name="'Billing_'+new Date().getTime()+'.xls'"
          >Export to Excel</download-excel>
        </v-btn>
      <v-btn v-if="allBilling.length>0" color="light-green" round class="white--text" @click="approveBilling()">Review & Send</v-btn>
      <v-btn round color="primary" class="white--text" v-if="xeroUrl" :href="xeroUrl">Connect to Xero</v-btn>
        <v-btn v-if="allBilling.length>0"  round color="primary" class="white--text" @click="generateSystemTransactions()">Generate System Transactions</v-btn>
    </v-toolbar>
    <billing :key="key" :billingData="allBilling" :layertwobilling="layerTwoBilling" :runBilling="runBilling"></billing>
    <v-dialog v-model="selectOrgModal" persistent width="750px">
      <v-card flat color="white">
        <v-toolbar flat color="primary">
          <h3 class="title white--text">Select an Organisation to Bill from:</h3>
        </v-toolbar>
        <v-card-text ma-1>
          <v-layout justify-center>
            <v-flex xs4 ma-1>
            <v-select :items="xeroOrganisations" item-text="orgData.name" item-value="orgData.organisationId" label="Organisation" return-object v-model="selectedOrganisation"></v-select>
          </v-flex>
          </v-layout>
          
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn v-if="selectedOrganisation" round color="primary" class="white--text" @click="prepInvoiceData()">Done</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="billingModal" persistent width="1000px">
      <v-card>
        <v-toolbar flat color="primary">
          <h3 class="title white--text">Invoice Settings</h3>
          <v-spacer></v-spacer>
          <v-btn color="white" flat v-if="!sendingInvoices&&billingItem.dueDate&&billingItem.reference" @click="sendInvoices()">Approve</v-btn>
          <v-btn round v-if="sendingInvoices" disabled>Sending Invoices <v-progress-circular
                          size="20"
                          indeterminate
                          color="white"
                        ></v-progress-circular></v-btn>
          <v-btn flat color="white" @click="billingModal=false, billingItem={}, selectedBilling=[]">X</v-btn>
        </v-toolbar>
        <v-card-text ma-1 style="overflow-y: auto; height:750px">
          <v-layout justify-center align-center wrap>
            <v-flex xs4 mx-1 v-if="$store.state.currentOrg.org.accountingSystem=='Xero'">
              <v-select label="Invoice Status" :items="invoiceStatuses" v-model="billingItem.invoiceStatus"></v-select>
            </v-flex>
            <v-flex xs4 mx-1>
              <v-text-field label="Invoice reference" v-model="billingItem.reference"></v-text-field>
            </v-flex>
            <v-flex xs4 mx-1>
               <v-menu :close-on-content-click="false">
                <v-text-field
                  id="addDateId"
                  :value="this.billingItem.dueDate"
                  slot="activator"
                  required
                  label="Due Date"
                  prepend-icon="date_range"
                ></v-text-field>
                <v-date-picker v-model="billingItem.dueDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs4 mx-1 v-if="$store.state.currentOrg.org.accountingSystem=='Xero'">
              <v-select label="Amount Tax Type" :items="lineAmountTypes" v-model="billingItem.lineAmountType"></v-select>
            </v-flex>
            <!-- <v-flex xs4 mx-1>
              <v-checkbox v-model="billingItem.sendEmail" label="Email Invoice(s)"></v-checkbox>
            </v-flex> -->
            
            <v-flex xs10 mx-1>
              <h3 class="grey--text">Invoices Breakdown:</h3>
            </v-flex>
            <v-flex xs10 mx-1 v-for="invoice in invoiceData" :key="invoice.organisationId">
              <v-card color="white" hover class="text-xs-left my-2">
                   <v-layout justify-center align-center wrap>
                <v-flex xs10 mx-1 class="text-xs-right">
                  <v-layout  align-center wrap>
                    <h3 class="title grey--text text-xs-left" mx-1>
                      {{invoice.name}}
                      </h3>
                  <v-spacer></v-spacer>
                   <v-btn v-show="allBilling.length>0" round color="primary">
          <v-icon>get_app</v-icon>
          <download-excel
            :data="invoice.accounts"
            :fields="exportFields"
            worksheet="export"
            :name="'Billing_'+new Date().getTime()+'.xls'"
          >Export to Excel</download-excel>
        </v-btn>
                      <v-chip v-if="invoice.accountingId" color="light-green" class="white--text"><v-icon color="white">check_circle_outline</v-icon></v-chip><v-chip v-else color="orange" class="white--text"><v-icon color="white">warning</v-icon></v-chip>
                  </v-layout>
                </v-flex>
                <v-toolbar flat color="white">
                  <h3 class="title grey--text font-weight-light">{{invoice.lineItems.reduce((a, b) => +a + +b.amount, 0) | currency}} excl. VAT</h3>
                </v-toolbar>
                <v-flex xs12 mx-1>
                    <v-data-table :items="invoice.lineItems" :headers="headers">
                      <template  v-slot:items="props">
                        <td>{{props.item.description}}</td>
                        <td>{{props.item.accountName&&props.item.accountName.name?props.item.accountName.name:props.item.accountName&&props.item.accountName.code?props.item.accountName.code:null}}</td>
                        <td v-if="$store.state.currentOrg.org.accountingSystem=='SageOne'">{{props.item.taxTypeId?taxTypes.find(x=>x.id==props.item.taxTypeId).name:props.item.taxTypeId}}</td>
                       <td v-else-if="$store.state.currentOrg.org.accountingSystem=='Xero'">
                         {{props.item.taxTypeId?taxTypes.find(x=>x.taxType==props.item.taxTypeId).name:null}}
                       </td>
                       <td v-else></td>
                        <td>{{props.item.quantity}}</td>
                        <td>{{props.item.amount | currency}}</td>
                      </template>

                    </v-data-table>
                  <v-divider></v-divider>
                </v-flex>
              </v-layout>
              </v-card>
             

            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

  <!-- Backup Invoice Dialog -->
    <!-- <v-dialog v-model="billingModal" persistent width="750px">
      <v-card>
        <v-toolbar flat color="primary">
          <h3 class="title white--text">Invoice Settings</h3>
          <v-spacer></v-spacer>
          <v-btn color="white" flat v-if="!sendingInvoices&&billingItem.invoiceStatus&&billingItem.lineAmountType&&billingItem.taxRate&&billingItem.dueDate&&billingItem.reference&&billingItem.recurringDescription&&billingItem.onceOffDescription&&billingItem.onceOffAccountCode&&billingItem.recurringAccountCode" @click="sendInvoices()">Approve</v-btn>
          <v-btn round v-if="sendingInvoices" disabled>Sending Invoices <v-progress-circular
                          size="20"
                          indeterminate
                          color="white"
                        ></v-progress-circular></v-btn>
          <v-btn flat color="white" @click="billingModal=false, billingItem={}, selectedBilling=[]">X</v-btn>
        </v-toolbar>
        <v-card-text ma-1>
          <v-layout justify-center align-center wrap>
            <v-flex xs4 mx-1>
              <v-select label="Invoice Status" :items="invoiceStatuses" v-model="billingItem.invoiceStatus"></v-select>
            </v-flex>
            <v-flex xs4 mx-1>
              <v-text-field label="Invoice reference" v-model="billingItem.reference"></v-text-field>
            </v-flex>
            <v-flex xs4 mx-1>
              <v-select label="Amount Tax Type" :items="lineAmountTypes" v-model="billingItem.lineAmountType"></v-select>
            </v-flex>
            <v-flex xs4 mx-1>
              <v-select label="Tax Rate" :items="xeroTaxRates" item-text="name" item-value="taxType" v-model="billingItem.taxRate"></v-select>
            </v-flex>
            <v-flex xs4 mx-1>
              <v-autocomplete :items="xeroAccounts" label="Xero Account: Once-off Sales" item-text="name" item-value="code" v-model="billingItem.onceOffAccountCode"></v-autocomplete>
            </v-flex>
            <v-flex xs4 mx-1>
              <v-text-field label="Once Off Sales Item Description" v-model="billingItem.onceOffDescription"></v-text-field>
            </v-flex>
            <v-flex xs4 mx-1>
              <v-autocomplete :items="xeroAccounts" label="Xero Account: Recurring Sales" item-text="name" item-value="code" v-model="billingItem.recurringAccountCode"></v-autocomplete>
            </v-flex>
            <v-flex xs4 mx-1>
              <v-text-field label="Recurring Sales Description" v-model="billingItem.recurringDescription"></v-text-field>
            </v-flex>
            <v-flex xs4 mx-1>
               <v-menu :close-on-content-click="false">
                <v-text-field
                  id="addDateId"
                  :value="this.billingItem.dueDate"
                  slot="activator"
                  required
                  label="Due Date"
                  prepend-icon="date_range"
                ></v-text-field>
                <v-date-picker v-model="billingItem.dueDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs4 mx-1>
              <v-checkbox v-model="billingItem.sendEmail" label="Email Invoice(s)"></v-checkbox>
            </v-flex>
            
            <v-flex xs10 mx-1>
              <h3 class="grey--text">Invoices Breakdown:</h3>
            </v-flex>
            <v-flex xs8 mx-1 v-for="invoice in invoiceData" :key="invoice.organisationId">
              <v-card color="white" hover class="text-xs-left my-1">
                   <v-layout justify-center align-center wrap>
                <v-flex xs9 ma-1 class="text-xs-right">
                  <v-layout align-center wrap>
                    <h3 class="title grey--text text-xs-left" mx-1>
                      {{invoice.name}}
                      </h3>
                  <v-spacer></v-spacer>
                      <v-chip v-if="invoice.xeroContactId" color="light-green" class="white--text"><v-icon color="white">check_circle_outline</v-icon>Linked</v-chip><v-chip v-else color="orange" class="white--text"><v-icon color="white">warning</v-icon>Not Linked</v-chip>

                  </v-layout>
                  
                </v-flex>
                <v-flex xs12 mx-1 v-for="item in invoice.lineItems" :key="item.name">
                  <v-layout justify-center align-center wrap>
                    <v-flex xs4 mx-1>
                      <h4 class="grey--text font-weight-light" v-if="item.name=='Recurring'&&!billingItem.recurringAccountCode">{{item.name}} Sales</h4>
                      <h4 class="grey--text font-weight-light" v-else-if="item.name=='Recurring'&&billingItem.recurringAccountCode">Account Code: {{billingItem.recurringAccountCode}} (Recurring sales)</h4>
                      <h4 class="grey--text font-weight-light" v-else-if="item.name=='Once-Off'&&!billingItem.onceOffAccountCode">{{item.name}} Sales</h4>
                      <h4 class="grey--text font-weight-light" v-else-if="item.name=='Once-Off'&&billingItem.onceOffAccountCode">Account Code: {{billingItem.onceOffAccountCode}} (Once-Off sales)</h4>
                    </v-flex>
                    <v-flex xs7 class="text-xs-right">
                      <h4 class="grey--text"><b>{{item.amount | currency}}</b> excl. VAT</h4>
                    </v-flex>
                  </v-layout>
                  <v-divider></v-divider>
                </v-flex>
                <v-flex class="text-xs-right" v-if="invoice.lineItems.length>1">
                <h3 class="grey--text">Total: {{invoice.lineItems.reduce((a, b) => +a + +b.amount, 0) | currency}} excl. VAT</h3>

                </v-flex>
              </v-layout>
              </v-card>
             

            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog> -->


    <v-dialog v-model="invoiceSuccessModal" persistent width="750px">
      <v-card color="white" flat>
        <v-toolbar flat color="light-green">
          <h3 class="title white--text">
            Successfully created the following invoices:
          </h3>
        </v-toolbar>
        <v-card-text ma-1>
          <v-layout justify-center align-center wrap>
            <v-flex xs8 mx-1 v-for="invoice in successfulInvoices" :key="invoice.invoiceID">
              <v-layout justify-center align-center>
                <v-flex xs3 mx-1>
                  <h3 class="grey--text font-weight-light">{{invoice.invoiceNumber}}</h3>
                </v-flex>
                <v-flex xs3 mx-1>
                  <h3 class="grey--text font-weight-light">{{invoice.contact.name}}</h3>
                </v-flex>
                <v-flex xs3 mx-1>
                  <h3 class="grey--text font-weight-light">{{invoice.total | currency}}</h3>
                </v-flex>
                <v-flex xs3 mx-1>
                  <v-chip v-if="invoice.status == 'DRAFT'" color="blue" class="white--text">DRAFT</v-chip>
                  <v-chip v-else color="light-green" class="white--text">{{invoice.status}}</v-chip>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-card-actions>
            <v-layout justify-center>
              <v-btn round color="light-green" class="white--text" @click="invoiceSuccessModal=false, successfulInvoices=[]">Done</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from "@/services/Api";
import dateformat from "dateformat";
import Billing from "@/components/Billing.vue";
export default {
  components: {
    billing: Billing
  },
  data() {
    return {
      accountingAccounts: [],
      accountingItems: [],
      connectedOrgs: [],
      packagesFno: [],
      taxTypes: [],
      billingDetails: false,
      exportFields: {
        circuitNumber: "circuitNumber",
        node: "location.locationNetwork.locationNode.name",
        network: "location.locationNetwork.name",
        subNetwork: {
          callback: value => {
            if(value.location.locationNetworkSubComplexId !== null){
            return value.location.locationNetworkSubComplex.subComplexName;
            } else {
              return value.location.subComplexName
            }
          }
        },
        unit: "location.locationDescription",
        // {
        //   callback: value => {
        //     if (value.location.locationNetworkSubComplexId !== null) {
        //       return (
        //         value.location.unitNo +
        //         " " +
        //         value.location.locationNetworkSubComplex.subComplexName
        //       );
        //     } else {
        //       return value.location.unitNo;
        //     }
        //   }
        // },
        ispName: "packagesIsp.customerOrganisation.name",
        pppoeUsername: "pppoeUsername",
        fnoPackage: "packagesIsp.packagesFno.packageCode",
        downloadMbps: "packagesIsp.packagesFno.speedProfile.downloadMbps",
        initialActivation: {
          callback: value => {
            return this.formatDate(value.initialActivation);
          }
        },
        ispActivation: {
          callback: value => {
            return this.formatDate(value.ispActivationDate);
          }
        },
        ispDeactivation: {
          callback: value => {
            return this.formatDate(value.ispDeactivationDate);
          }
        },
        fnoActivation: {
          callback: value => {
            return this.formatDate(value.fnoActivationDate);
          }
        },
        fnoDeactivation: {
          callback: value => {
            return this.formatDate(value.fnoDeactivationDate);
          }
        },
        fnoPackagePrice: {
          callback: value => {
            if (value.location.locationNetwork.lineRentalIncluded&&value.packagesIsp.packagesFno.packagesFnoCat.packageCatType==='Residential') {
              return (
                value.packagesIsp.packagesFno.packageBasePrice -
                value.location.locationNetwork.residentialLineRentalValue
              );
            } else if (value.location.locationNetwork.lineRentalIncluded&&value.packagesIsp.packagesFno.packagesFnoCat.packageCatType==='Business') {
              return (
                value.packagesIsp.packagesFno.packageBasePrice -
                value.location.locationNetwork.businessLineRentalValue
              );
            } else {
              return value.packagesIsp.packagesFno.packageBasePrice;
            }
          }
        },
        billedFrom:  {
          callback: value => {
            return this.formatDate(value.startDate);
          }
        },
        billedTo: {
          callback: value => {
            return this.formatDate(value.endDate);
          }
        },
        "Data Activation Fee": 'onceOff',
        "VAS Billed": 'prorata'
          
        
      },
      allBilling: [],
      billingSummary: [],
      billingDate: new Date(),
      billingStart: null,
      billingEnd: null,
      billingItem: {},
      billingModal : false,
      startDay: null,
      endDay: null,
      startDate: null,
      endDate: null,
      daysInCurrentMonth: null,
      billedDays: 0,
      invoiceSuccessModal: false,
      key: 1,
      organisations: [],
      invoiceData: [],
      layerTwoBilling: [],
      runBilling: false,
      selectedOrganisation: null,
      selectOrgModal: false,
      sendingInvoices: false,
      successfulInvoices: [],
      xeroAccounts: [],
      xeroAccountContacts: [],
      xeroAuth: null,
      xeroContacts: [],
      xeroOrganisations: [],
      xeroUrl: null,
      xeroTaxRates: [],
      invoiceStatuses: ['DRAFT', 'SUBMITTED', 'AUTHORISED'],
      lineAmountTypes: ['Exclusive', 'Inclusive', 'NoTax'],
      headers: [
        {
          text: "Description",
          align: "center",
          value: "description"
        },
        {
          text: "Account Code",
          align: "center",
          value: "accountingId"
        },
        {
          text: "Tax Type",
          align: "center",
          value: "taxTypeId"
        },
        {
          text: "Quantity",
          align: "center",
          value: "quantity"
        },
        {
          text: "Amount",
          align: "center",
          value: "amount"
        },
      ]
    };
  },
  watch: {
    
    async setDate(value) {}
  },
  async created() {
    let route = await this.$store.state.currentOrg.org.permissions.filter(
      function(el) {
        return el.url === "/billing";
      }
    );
    if (route.length > 0) {
      await this.$store.dispatch("setCurrentRoute", route[0]);
      if (this.authRead(this.$store.state.currentRoute) === true) {
        this.initialize();
      }
    } else {
      this.$router.push({ name: "SplashPage" });
    }
  },
  methods: {
    formatDate(date) {
      if (date !== null) {
        return dateformat(date, "dd/mm/yyyy");
      } else {
        null;
      }
    },
    initialize(){
      this.fetchConnectedOrganisations()
      this.fetchFnoPackages()
      if(this.$store.state.currentOrg.org.accountingSystem == 'SageOne'){
        this.fetchSageAccounts()
          this.fetchSageItems()
          this.fetchSageTaxTypes()
      } else if(this.$store.state.currentOrg.org.accountingSystem == 'Xero'){
      this.getXeroLoginUrl()
      }
    },
    async fetchFnoPackages(){
      await Api().get('/packagesFnos/all').then(res=>{
        this.packagesFno = res.data
      })
    },
    async fetchConnectedOrganisations(){
      await Api().get('/organisationConnection').then(res=>{
        this.connectedOrgs = res.data
      })
    },
    async fetchSageAccounts(){
      await Api().get('/sageOne/accounts').then(res=>{
        let result = res.data.Results.filter(x=>x.Category.ID == 1)
        this.accountingAccounts = result.map(x=>({id: x.ID.toString(), name: x.Name}))
      })
    },
    async fetchSageItems(){
      await Api().get('/sageOne/items').then(res=>{
        this.accountingItems = res.data.Results.map(x=>({id: x.ID.toString(), name: x.Code}))
      })
    },
    async fetchSageTaxTypes(){
      await Api().get('/sageOne/taxTypes').then(res=>{
        this.taxTypes = res.data.Results.map(x=>({id: x.ID.toString(), name: x.Name}))
      })
    },

   async fetchXeroAccounts(){
      await Api().get('/xero/accounts').then(res=>{
        let result = res.data.body.accounts
        this.accountingAccounts = result.map(x=>({id: x.accountID, name: x.name}))
      })
    },
    async fetchXeroItems(){
      await Api().get('/xero/items').then(res=>{
        let result = res.data.body.items

        this.accountingItems = result.map(x=>({id: x.itemID, name: x.name}))
      })
    },
    async getbillingData(){
      // (this.startDay = new Date(this.setDate)),
          this.setDate = this.billingDate;
          let initialDate = new Date(this.setDate);
          this.startDay = new Date(this.billingStart)
          this.startDay.setHours(0,0,0,0)

            this.endDay = new Date(this.billingEnd)

          this.endDay.setHours(23,59,59,0)
          this.layerTwoBilling = [];
            await Api()
            .get("/serviceAccounts/billing/oneDevice", {
              params: {
                billingStart: this.billingStart,
                billingEnd: this.billingEnd
              }
            })
            .then(async response => {
              this.allBilling = response.data;
            })
            
              for (let i = 0; i < this.allBilling.length; i++) {
                let fnoPackage = this.packagesFno.find(x=>x.id === this.allBilling[i].packagesIsp.packagesFnoId)
                //   Recurring Billing
                if(fnoPackage){
                  this.allBilling[i].prorata = await this.calcuateRecurringBills(
                  this.allBilling[i], fnoPackage
                );
                } else {
                  console.log(this.allBilling[i])
                }
                
                
                this.allBilling[i].layerTwoProrata = fnoPackage.layerTwoPortion*(this.allBilling[i].prorata/fnoPackage.packageBasePrice)
                // Once Off Activations
                

                if (
                  new Date(this.allBilling[i].fnoActivationDate) <=
                    new Date(this.endDay) &&
                  new Date(this.allBilling[i].fnoActivationDate) >=
                    new Date(this.startDay) &&
                  this.allBilling[i].isChange === false
                ) {
                  if(fnoPackage.setupFee&&fnoPackage.setupFee!=0){
                    this.allBilling[i].onceOff = fnoPackage.setupFee
                  } else {
                    this.allBilling[i].onceOff = this.allBilling[
                    i
                  ].location.locationNetwork.activationFeeAmount;
                  }
                  
                } else if (
                  new Date(this.allBilling[i].fnoActivationDate) ===
                    new Date(this.endDay) ||
                  new Date(this.allBilling[i].fnoActivationDate) ===
                    new Date(this.startDay)
                ) {
                  if(fnoPackage.setupFee&&fnoPackage.setupFee!=0){
                    this.allBilling[i].onceOff = fnoPackage.setupFee
                  } else {
                      this.allBilling[i].onceOff = this.allBilling[
                    i
                  ].location.locationNetwork.activationFeeAmount;
                  }
                  
                } else {
                  
                  this.allBilling[i].onceOff = 0;
                }
                // Start Date
                if (
                  new Date(this.allBilling[i].fnoActivationDate) >=
                  new Date(this.startDay)
                ) {
                  new Date(this.allBilling[i].startDate = this.allBilling[
                    i
                  ].fnoActivationDate);
                } else {
                  this.allBilling[i].startDate = this.startDay;
                }
                // End Date
                if (
                  this.allBilling[i].fnoDeactivationDate !== null &&
                  this.allBilling[i].ispDeactivationDate === null &&
                  new Date(this.allBilling[i].fnoDeactivationDate) <=
                    new Date(this.endDay) &&
                  new Date(this.allBilling[i].fnoDeactivationDate) >=
                    new Date(this.startDay)
                ) {
                  new Date(this.allBilling[i].endDate = this.allBilling[
                    i
                  ].fnoDeactivationDate);
                } else if (
                  this.allBilling[i].fnoDeactivationDate === null &&
                  this.allBilling[i].ispDeactivationDate !== null &&
                  new Date(this.allBilling[i].ispDeactivationDate) <=
                    new Date(this.endDay) &&
                  new Date(this.allBilling[i].ispDeactivationDate) >=
                    new Date(this.startDay)
                ) {
                  this.allBilling[i].endDate = this.allBilling[
                    i
                  ].ispDeactivationDate;
                } else if (
                  this.allBilling[i].fnoDeactivationDate !== null &&
                  this.allBilling[i].ispDeactivationDate !== null &&
                  new Date(this.allBilling[i].fnoDeactivationDate) >=
                    new Date(this.allBilling[i].ispDeactivationDate) &&
                    new Date(this.allBilling[i].fnoDeactivationDate) <=
                      new Date(this.endDay) &&
                    new Date(this.allBilling[i].fnoDeactivationDate) >=
                      new Date(this.startDay)
                ) {
                  this.allBilling[i].endDate = this.allBilling[
                    i
                  ].fnoDeactivationDate;
                } else if (
                  this.allBilling[i].fnoDeactivationDate !== null &&
                  this.allBilling[i].ispDeactivationDate !== null &&
                  new Date(this.allBilling[i].fnoDeactivationDate) <=
                    new Date(this.allBilling[i].ispDeactivationDate) &&
                    new Date(this.allBilling[i].ispDeactivationDate) <=
                      new Date(this.endDay) &&
                    new Date(this.allBilling[i].ispDeactivationDate) >=
                      new Date(this.startDay)
                ) {
                  this.allBilling[i].endDate = this.allBilling[
                    i
                  ].ispDeactivationDate;
                } else {
                  this.allBilling[i].endDate = this.endDay;
                }
              }
          this.key += 1;
    },
     getXeroLoginUrl(){
      // debugger
      Api().get('/xero/authenticate').then(response=>{
        if(response.data.url){
        this.xeroUrl = response.data.url
        if(this.$route.query.code){
          this.getXeroTokens(this.xeroUrl)
      }} else if(response.data.tokenSet){
        this.xeroAuth = response.data.tokenSet
        this.getXeroOrganisations()
      }
      })
    },
    getXeroTokens(){
      Api().get('/xero/callback', {
        params:  this.$route.query
      }).then(response=>{
        if(response.data.tokenSet){
          // console.log(response.data)
          this.xeroAuth = response.data.tokenSet
          // console.log(this.xeroAuth)
          this.key+=1
          this.getXeroOrganisations()
        }
      })
    },
    getXeroTaxRates(tenantId){
      Api().get('/xero/taxRates').then(response=>{
        console.log(response.data)
        this.xeroTaxRates = response.data.body.taxRates
      })
    },
    getXeroContacts(tenantId){
      Api().get('/xero/contacts').then(response=>{
        if(response.data.body.contacts){
        this.xeroContacts = response.data.body.contacts
        }
        
      })
    },
    getXeroAccounts(tenantId){
      Api().get('/xero/accounts/'+tenantId).then(response=>{
        if(response.data.body.accounts){
        this.xeroAccounts = response.data.body.accounts
        }
        
      })
    },
    getXeroOrganisations(){
      Api().get('/xero/getOrganisations').then(response=>{
        this.xeroOrganisations = response.data
        if(this.xeroOrganisations.length>1){
        this.selectOrgModal= true
        } else {
          this.selectedOrganisation = this.xeroOrganisations[0]
          this.prepInvoiceData()
        }
      })
    },
    getLinkedAccounts(tenantId){
      Api().get('/xeroAccountContact').then(response=>{
        this.xeroAccountContacts = response.data
      })
    },
     async prepInvoiceData(){
      // await this.getLinkedAccounts()
      this.fetchXeroAccounts()
      this.fetchXeroItems()
      await this.getXeroTaxRates(this.$store.state.currentOrg.org.accountingId)
      await this.getXeroContacts(this.$store.state.currentOrg.org.accountingId)
      this.getXeroAccounts(this.$store.state.currentOrg.org.accountingId)
      this.selectOrgModal = false
    },
    async calcuateRecurringBills(item, fnoPackage) {
      var one_day = 1000 * 60 * 60 * 24
      // this.getStart(item.fnoActivationDate, item.ispActivationDate);
      if (new Date(item.fnoActivationDate) >= new Date(this.startDay)) {
        this.startDate = new Date(item.fnoActivationDate);
      } else {
        this.startDate = new Date(this.startDay);
      }
      if (
        item.fnoDeactivationDate === null
      ) {
        this.endDate = new Date(this.endDay);
      } else if (
        item.fnoDeactivationDate !== null &&
        new Date(item.fnoDeactivationDate) <= new Date(this.endDay) &&
        new Date(item.fnoDeactivationDate) >= new Date(this.startDay)
      ) {
        this.endDate = new Date(item.fnoDeactivationDate);
      }  else if (
        item.fnoDeactivationDate !== null
      ) {
        if (
          new Date(item.fnoDeactivationDate) > new Date(this.endDay)
        ) {
          this.endDate = new Date(this.endDay);
        }
      }
      let setDate = new Date(this.setDate);
      this.daysInCurrentMonth = Math.round(
        Math.abs(this.endDay.getTime() - this.startDay.getTime()) / one_day
      );
      
      // this.startDate = new Date(this.startDate);
      this.startDate = new Date(this.startDate.getFullYear(), this.startDate.getMonth(), this.startDate.getDate())
      this.startDate.setHours(0,0,0,0);
      this.endDate = new Date(this.endDate.getFullYear(), this.endDate.getMonth(), this.endDate.getDate())
      this.endDate.setHours(23,59,59,0);
      let billedAmount = fnoPackage.packageBasePrice;
      this.billedDays = Math.round(
        (Math.abs(this.endDate.getTime() - this.startDate.getTime()) / one_day)
      );
      if(this.billedDays>this.daysInCurrentMonth){
        this.billedDays = this.daysInCurrentMonth
      }
      if (
        item.location.locationNetwork.lineRentalIncluded &&
        fnoPackage.packagesFnoCat.packageCatType ===
          "Residential"
      ) {
        billedAmount =
          billedAmount -
          item.location.locationNetwork.residentialLineRentalValue;
      } else if (
        item.location.locationNetwork.lineRentalIncluded &&
        fnoPackage.packagesFnoCat.packageCatType ===
          "Business"
      ) {
        billedAmount =
          billedAmount - item.location.locationNetwork.businessLineRentalValue;
      }
      return (
        Math.round(
          (this.billedDays / this.daysInCurrentMonth) * billedAmount * 100
        ) / 100
      );
    },
    generateSystemTransactions(){
      if(this.authCreate(this.$store.state.currentRoute)){
        confirm('Are you sure you want to proceed? WARNING: This action cannot be undone.')&&
        (this.runBilling = true)
      }
    },
    async fetchInstallsByCustomer(start, end, organisationId){
      let result = []
      await Api().get('/applications/installs/'+organisationId, {
        params: {
          start: start,
          end: end
        }
      }).then(res=>{
        result = res.data
      })
      return result
    },
    async approveBilling(){
      // this.invoiceData
      this.billingItem = {
        sendEmail: false
      }
      let organisations = [
            ...new Set(
              this.allBilling.map(
                item => item.packagesIsp.customerOrganisationId
              )
            )
          ];
          this.invoiceData = []
          for(let x=0; x< organisations.length;x++){
            let find = await this.connectedOrgs.find(y=>y.connectedOrganisationId === organisations[x])
            if(find){
              let obj = {
              organisationId: organisations[x],
              name: find.connectedOrganisation.name,
              accountingId: find.accountingId,
              lineItems: [],
              accounts: await this.allBilling.filter(a=>
              a.customerOrganisationId==organisations[x]
            )
            }
            let onceOffData = await this.allBilling.filter(z=>
              z.onceOff>0&&z.customerOrganisationId==organisations[x]
            )

            if(this.$store.state.currentOrg.org.billIsp){
              let installs = await this.fetchInstallsByCustomer(this.billingStart, this.billingEnd, organisations[x])
              if(installs.length>0){
                await obj.lineItems.push({
              accountingId: this.$store.state.currentOrg.org.installAccountCode,
              description: 'Installation Fee',
              taxTypeId: this.$store.state.currentOrg.org.taxType,
              type: 'install',
              accountType: this.$store.state.currentOrg.org.installFeeType,
              accountName: this.$store.state.currentOrg.org.installAccountCode?this.$store.state.currentOrg.org.installFeeType=='Account'?this.accountingAccounts.find(a=>a.id == this.$store.state.currentOrg.org.installAccountCode):this.accountingItems.find(a=>a.id == this.$store.state.currentOrg.org.installAccountCode):null,
              quantity: this.$store.state.currentOrg.org.installFeeType == 'Item'?installs.length:1, 
              amount: installs.reduce((a, b) => +a + +b.routerInstallationFee/(1+$VAT), 0)})
              }
            }
            
            if(onceOffData.length>0){
              await obj.lineItems.push({
              accountingId: this.$store.state.currentOrg.org.setupAccountCode,
              description: 'Setup Fee',
              taxTypeId: this.$store.state.currentOrg.org.taxType,
              type: 'setup',
              accountType: this.$store.state.currentOrg.org.setupFeeType,
              accountName: this.$store.state.currentOrg.org.setupAccountCode?this.$store.state.currentOrg.org.setupFeeType=='Account'?this.accountingAccounts.find(a=>a.id == this.$store.state.currentOrg.org.setupAccountCode):this.accountingItems.find(a=>a.id == this.$store.state.currentOrg.org.setupAccountCode):null,
              quantity: this.$store.state.currentOrg.org.setupFeeType == 'Item'?onceOffData.length:1, 
              amount: onceOffData.reduce((a, b) => +a + +b.onceOff, 0)})
            }
            let recurringData = await this.allBilling.filter(z=>
              z.packagesIsp.customerOrganisationId == organisations[x]
            )
            let uniquePackages = [...new Set(recurringData.map(x=>x.packagesIsp.packagesFnoId))]
            if(recurringData.length>0){
              for(let y=0;y< uniquePackages.length;y++){
                let fnoPackage = this.packagesFno.find(z=>z.id==uniquePackages[y])
                  await obj.lineItems.push({
                accountingId: fnoPackage.accountCode,
                description: fnoPackage.packageCode,
                taxTypeId: this.$store.state.currentOrg.org.taxType,
                type: 'package',
                accountType:fnoPackage.accountType,
                accountName: fnoPackage.accountCode?fnoPackage.accountType=='Account'?this.accountingAccounts.find(a=>a.id == fnoPackage.accountCode):this.accountingItems.find(a=>a.id == fnoPackage.accountCode):null,
                quantity: fnoPackage.accountType == 'Item'?recurringData.filter(x=>x.packagesIsp.packagesFnoId === uniquePackages[y]).length: 1, 
                amount: recurringData.filter(x=>x.packagesIsp.packagesFnoId === uniquePackages[y]).reduce((a, b) => +a + +b.prorata, 0)
                })                
              }
            }
            await this.invoiceData.push(obj)
            } else {
              console.log('Cannot find', organisations[x])
            }
          }
          console.log(this.invoiceData)
      this.billingModal=true
    },
    async sendInvoices(){
      this.sendingInvoices = true
      console.log(this.billingItem)
      let billableOrgs = this.invoiceData.filter(x=>x.accountingId)
      let invoice = []
      let today = new Date()
      let due = new Date(this.billingItem.dueDate)
      if(this.$store.state.currentOrg.org.accountingSystem == 'SageOne'){
        for (let i=0;i<billableOrgs.length;i++){
          billableOrgs[i].customerOrganisationId = billableOrgs[i].organisationId
          for(let j=0;j<billableOrgs[i].lineItems.length;j++){
            billableOrgs[i].lineItems[j].SelectionId = billableOrgs[i].lineItems[j].accountingId
            billableOrgs[i].lineItems[j].LineType = billableOrgs[i].lineItems[j].accountType=='Item'?0:1
            billableOrgs[i].lineItems[j].Quantity = billableOrgs[i].lineItems[j].quantity
            billableOrgs[i].lineItems[j].Description = billableOrgs[i].lineItems[j].description
            billableOrgs[i].lineItems[j].TaxTypeId = billableOrgs[i].lineItems[j].taxTypeId
            billableOrgs[i].lineItems[j].UnitPriceExclusive = billableOrgs[i].lineItems[j].amount
          }
        }
        await billableOrgs.forEach(x=>{
          invoice.push({
            customerOrganisationId: x.customerOrganisationId,
            CustomerId: x.accountingId,
          Reference:  this.billingItem.reference,
          Date: [today.getFullYear(), (today.getMonth()+1)<10?'0'+(today.getMonth()+1).toString():today.getMonth()+1, today.getDate()<10?'0'+today.getDate().toString():today.getDate()].join('-'),
          DueDate: [due.getFullYear(), (due.getMonth()+1)<10?'0'+(due.getMonth()+1).toString():due.getMonth()+1, due.getDate()<10?'0'+due.getDate().toString():due.getDate()].join('-'),
          Lines: x.lineItems.filter(y=>y.SelectionId&&y.SelectionId!='NULL')})
        })
        for(let i=0; i< invoice.length;i++){
        await Api().post('/sageOne/createInvoice', invoice[i])
      }
      } else if(this.$store.state.currentOrg.org.accountingSystem == 'Xero'){
        for (let i=0;i<billableOrgs.length;i++){
          billableOrgs[i].customerOrganisationId = billableOrgs[i].organisationId
                  let obj = {
  type: "ACCREC",
  contact: { 
    contactID: billableOrgs[i].accountingId
  },
  date: new Date().toISOString()
              .substr(0, 10),
  dueDate: this.billingItem.dueDate,
  dateString: new Date().toISOString()
              .substr(0, 10),
  dueDateString: this.billingItem.dueDate.toString(),
  lineAmountTypes: this.billingItem.lineAmountType,
  reference: this.billingItem.reference,
  status: this.billingItem.invoiceStatus,
  lineItems: billableOrgs[i].lineItems
}
          for(let j=0;j<obj.lineItems.length;j++){
            obj.lineItems[j].accountCode = billableOrgs[i].lineItems[j].accountingId
            // billableOrgs[i].lineItems[j].LineType = billableOrgs[i].lineItems[j].accountType=='Item'?0:1
            obj.lineItems[j].quantity = billableOrgs[i].lineItems[j].quantity
            obj.lineItems[j].description = billableOrgs[i].lineItems[j].description
            obj.lineItems[j].taxType = billableOrgs[i].lineItems[j].taxTypeId
            obj.lineItems[j].unitAmount = billableOrgs[i].lineItems[j].amount

            // obj.lineItems.push({
//       description: this.billingItem.recurringDescription,
//       quantity: x.lineItems[y].quantity,
//       unitAmount: x.lineItems[y].amount,
//       accountCode: this.billingItem.recurringAccountCode,
//       taxType: this.billingItem.taxRate,
//       sendEmail: this.billingItem.sendEmail
//     })
          }
          invoice.push(obj)
        }
      console.log(invoice)
            let sendData = await this.allBilling.map(x=>({
        serviceAccountId: x.id,
        ispId: x.packagesIsp.customerOrganisationId,
        ispName: x.packagesIsp.customerOrganisation.name,
        node: x.location.locationNetwork.locationNode.name,
        network: x.location.locationNetwork.name,
        unit: x.location.locationDescription,
        pppoeUsername: x.pppoeUsername,
        fnoPackage: x.packagesIsp.packagesFno.packageCode,
        fnoPackagePrice: x.packagesIsp.packagesFno.packageBasePrice,
        downloadMbps: x.packagesIsp.packagesFno.speedProfile.downloadMbps,
        uploadMbps: x.packagesIsp.packagesFno.speedProfile.uploadMbps,
        initialActivation:  this.formatDate(x.initialActivation),
        fnoActivation: this.formatDate(x.fnoActivationDate),
        fnoDeactivation: this.formatDate(x.fnoDeactivationDate),
        billedFrom: this.formatDate(x.startDate),
        billedTo: this.formatDate(x.endDate),
        setupFeeCharged: x.onceOff,
        monthlyFeeCharged: x.prorata
        }))

              await Api().post('/xero/invoices/'+this.$store.state.currentOrg.org.accountingId, {billingData: sendData, invoices: invoice})
      .then(response=>{
        if(response.data.response.statusCode==200){
          this.successfulInvoices = response.data.body.invoices
          this.invoiceSuccessModal=true
          this.sendingInvoices = false
        }
        this.billingItem={}
        this.invoiceData = []
        this.billingModal = false
      })
      this.runBilling=true
      }

      this.billingModal = false

      // else if(this.$store.state.currentOrg.org.accountingSystem == 'Xero'){
//       await billableOrgs.forEach(async x=>{
//         let obj = {
//   type: "ACCREC",
//   contact: { 
//     contactID: x.xeroContactId 
//   },
//   date: new Date().toISOString()
//               .substr(0, 10),
//   dueDate: this.billingItem.dueDate,
//   dateString: new Date().toISOString()
//               .substr(0, 10),
//   dueDateString: this.billingItem.dueDate.toString(),
//   lineAmountTypes: this.billingItem.lineAmountType,
//   reference: this.billingItem.reference,
//   status: this.billingItem.invoiceStatus,
//   lineItems: []
// }

// for (let y=0; y<x.lineItems.length;y++){
//   if(x.lineItems[y].name=='Recurring'){
//     obj.lineItems.push({
//       description: this.billingItem.recurringDescription,
//       quantity: x.lineItems[y].quantity,
//       unitAmount: x.lineItems[y].amount,
//       accountCode: this.billingItem.recurringAccountCode,
//       taxType: this.billingItem.taxRate,
//       sendEmail: this.billingItem.sendEmail
//     })
//   } else if(x.lineItems[y].name=='Once-Off') {
// obj.lineItems.push({
//       description: this.billingItem.onceOffDescription,
//       quantity: x.lineItems[y].quantity,
//       unitAmount: x.lineItems[y].amount,
//       accountCode: this.billingItem.onceOffAccountCode,
//       taxType: this.billingItem.taxRate,
//       sendEmail: this.billingItem.sendEmail
//     })
//   }
// }
// invoice.push(obj)
//       })

//       await Api().post('/xero/invoices/'+this.selectedOrganisation.tenantId, {billingData: sendData, invoices: invoice})
//       .then(response=>{
//         if(response.data.response.statusCode==200){
//           this.successfulInvoices = response.data.body.invoices
//           this.invoiceSuccessModal=true
//           this.sendingInvoices = false
//         }
//         this.billingItem={}
//         this.invoiceData = []
//         this.billingModal = false
//       })
//       this.runBilling=true
//       }
    }
  }
};
</script>
